/**
 * @file
 * Behaviors for the Level navigation.
 *
 */

!((Drupal, $) => {
  'use strict';

  Drupal.behaviors.levelNavigation = {
    attach: function(context) {
      const levels = [
        'barnehage',
        'barnetrinn',
        'ungdomstrinn',
        'videregående',
        'eiere-og-ledelse'
      ];

      const headerLevelButton = '.lohkanguovddas-header__levels-button';
      const activeLevelElement =
        '<span class="lohkanguovddas-header__active-level lohkanguovddas-header__link-text"></span>';
      const activeLevel = '.lohkanguovddas-header__active-level';
      const defaultLevelText = '.lohkanguovddas-header__link-text--level';
      const levelMenu = '.lohkanguovddas-header__level-menu';
      const nodeTheme = '.page-node-type-theme.navigated-from--';
      const nodeTaxonomy = '.path-taxonomy.navigated-from--';
      const nodePackage = '.page-node-type-package.navigated-from--';
      const nodeSession = '.page-node-type-session.navigated-from--';
      const viewsRow = '.view-content > .views-row';
      const fieldName = '.field--name-name';
      const fieldIcon = '.field--name-field-icon';
      const nodeClasses = $('body')
        .attr('class')
        .split(/\s+/);
      let lastTermClass = '';
      let checkClass = false;

      /**
       * @function
       * levelDisplay function for displaying the level names.
       * @param {string} levelName - Current node level name.
       * @param {number} levelIndex - level index in the view.
       */
      function levelDisplay(levelName, levelIndex) {
        const nodehasLevel =
          $('body', context).is(nodeTheme + levelName) ||
          $('body', context).is(nodeTaxonomy + levelName) ||
          $('body', context).is(nodePackage + levelName) ||
          $('body', context).is(nodeSession + levelName);

        if (nodehasLevel) {
          $(headerLevelButton).prepend(activeLevelElement);
          $(defaultLevelText).hide();
          $(levelMenu)
            .find(viewsRow)
            .eq(levelIndex)
            .find(fieldName)
            .clone()
            .appendTo(activeLevel);
          $(levelMenu)
            .find(viewsRow)
            .eq(levelIndex)
            .find(fieldIcon)
            .clone()
            .appendTo(activeLevel);
        }
      }

      /**
       * @function
       * noCookielevelDisplay function for displaying the level names
       * when there is no cookie.
       */

      function noCookieLevelDisplay() {
        const levelNode =
          $('body', context).is('.page-node-type-theme') ||
          $('body', context).is('.path-taxonomy') ||
          $('body', context).is('.page-node-type-package') ||
          $('body', context).is('.page-node-type-session');
        if (levelNode) {
          $(headerLevelButton).prepend(activeLevelElement);
          $(defaultLevelText).hide();
          const rows = $(levelMenu)
            .find(viewsRow)
            .find(fieldName);
          $.each(rows, function(index, item) {
            let termName = $(item).text();
            termName =
              'term-name--' + termName.replace(/\s+/g, '-').toLowerCase();
            if (lastTermClass === termName) {
              $(levelMenu)
                .find(viewsRow)
                .eq(index)
                .find(fieldName)
                .clone()
                .appendTo(activeLevel);
              $(levelMenu)
                .find(viewsRow)
                .eq(index)
                .find(fieldIcon)
                .clone()
                .appendTo(activeLevel);
              return false;
            }
          });
        }
      }

      $.each(nodeClasses, function(index, item) {
        if (item.startsWith('term-name--')) {
          lastTermClass = item;
        }
        if (item.startsWith('navigated-from--')) {
          checkClass = true;
        }
      });

      /**
       * Initialize the levelDisplay
       */
      if (checkClass) {
        for (
          let i = 0, j = 0;
          i < levels.length && j < levels.length;
          i++, j++
        ) {
          levelDisplay(levels[i], j);
        }
        checkClass = false;
      }
      else {
        /**
         * Initialize the noCookielevelDisplay
         */
        noCookieLevelDisplay();
      }
    }
  };
})(Drupal, jQuery);
